// Libs
import React, { useState, useContext } from "react";
import { StoresContext, Stores } from "Globals/Stores";
import { useObserver, EditableInput } from "@shoothill/core";

import { Table, TableBody, TableRow, TableContainer, TableCell, Box, Button, TableHead } from "@material-ui/core";
import styled from "styled-components";
import { BinSVG } from "Globals/Views/IconSVGs/BinSVG";

// App
import { theme } from "Globals/Styles/AppTheme";
import PersonalDetailsViewModel from "Globals/ViewModels/FormSections/PersonalDetails/PersonalDetailsViewModel";
import FamilyAddressViewModel from "Globals/ViewModels/FormSections/PersonalDetails/FamilyAddressViewModel";
import ApplicationFormViewModel from "Globals/ViewModels/ApplicationFormViewModel";

// Styles
import { Row } from "Globals/Styles/LayoutStyles";

export const StyledAddButton = styled(Button)`
    display: flex;
    flex-direction: row;
    justify-content: center;
    font-size: 12px;
    align-items: center;
    background-color: ${theme.palette.hightownBlue.light};
    color: ${theme.palette.common.white};
    &.Mui-disabled {
        color: ${theme.palette.common.white};
        opacity: 0.5;
    }
    :hover {
        background-color: ${theme.palette.hightownBlue.light};
    }
    width: 32px;
    height: 32px;
    min-width: 32px;
    min-height: 32px;
    padding: 0px;
    margin: 0 0 1px 0;
`;
interface IProps {
    personalDetailsViewModel: PersonalDetailsViewModel;
    applicationFormViewModel: ApplicationFormViewModel;
}

export const FamilyAddressView: React.FC<IProps> = (props: IProps) => {
    const storesContext = useContext<Stores>(StoresContext);
    const [upsertViewModel] = useState(() => new FamilyAddressViewModel());
    return useObserver(() => (
        <>
            <Box>
                {(upsertViewModel.IsLoading || props.applicationFormViewModel.model.isSubmitted || storesContext.Domain.SaveStore.isSaving) == false && (
                    <>
                        <Row>
                            <EditableInput
                                label="Current address line 1"
                                placeHolder="Address line 1"
                                viewModel={upsertViewModel}
                                fieldName="addressLine1"
                                shrink={true}
                                inputProps={{
                                    disabled: upsertViewModel.IsLoading || props.applicationFormViewModel.model.isSubmitted || storesContext.Domain.SaveStore.isSaving,
                                }}
                            />
                            <EditableInput
                                label="Current address line 2"
                                placeHolder="Address line 2"
                                viewModel={upsertViewModel}
                                fieldName="addressLine2"
                                shrink={true}
                                inputProps={{
                                    disabled: upsertViewModel.IsLoading || props.applicationFormViewModel.model.isSubmitted || storesContext.Domain.SaveStore.isSaving,
                                }}
                            />
                            <EditableInput
                                label="Current address line 3"
                                placeHolder="Address line 3"
                                viewModel={upsertViewModel}
                                fieldName="addressLine3"
                                shrink={true}
                                inputProps={{
                                    disabled: upsertViewModel.IsLoading || props.applicationFormViewModel.model.isSubmitted || storesContext.Domain.SaveStore.isSaving,
                                }}
                            />
                        </Row>
                        <Row style={{ alignItems: "center" }}>
                            <EditableInput
                                label="City/Town"
                                placeHolder="City/Town"
                                viewModel={upsertViewModel}
                                fieldName="city"
                                shrink={true}
                                inputProps={{
                                    disabled: upsertViewModel.IsLoading || props.applicationFormViewModel.model.isSubmitted || storesContext.Domain.SaveStore.isSaving,
                                }}
                            />
                            <EditableInput
                                label="Property county"
                                placeHolder="County"
                                viewModel={upsertViewModel}
                                fieldName="county"
                                shrink={true}
                                inputProps={{
                                    disabled: upsertViewModel.IsLoading || props.applicationFormViewModel.model.isSubmitted || storesContext.Domain.SaveStore.isSaving,
                                }}
                            />
                            <EditableInput
                                label="Postcode"
                                placeHolder="Postcode"
                                viewModel={upsertViewModel}
                                fieldName="postcode"
                                shrink={true}
                                inputProps={{
                                    disabled: upsertViewModel.IsLoading || props.applicationFormViewModel.model.isSubmitted || storesContext.Domain.SaveStore.isSaving,
                                }}
                            />
                            <Box style={{ display: "flex", alignItems: "start", marginTop: "22px" }}>
                                <StyledAddButton
                                    variant="contained"
                                    disableElevation
                                    onClick={() => upsertViewModel.stash(props.personalDetailsViewModel)}
                                    disabled={upsertViewModel.IsLoading || props.applicationFormViewModel.model.isSubmitted || storesContext.Domain.SaveStore.isSaving}
                                >
                                    +
                                </StyledAddButton>
                            </Box>
                        </Row>
                    </>
                )}
                {props.personalDetailsViewModel.getSortedFamilyAddressViewModels.length > 0 && (
                    <TableContainer>
                        <Table style={{ width: "100%" }} aria-label="simple table">
                            <TableHead>
                                <TableRow>
                                    <TableCell>Address line 1</TableCell>
                                    <TableCell align="center">Address line 2</TableCell>
                                    <TableCell align="center">Address line 3</TableCell>
                                    <TableCell align="center">City/Town</TableCell>
                                    <TableCell align="center">County</TableCell>
                                    <TableCell align="center">Postcode</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {props.personalDetailsViewModel.getSortedFamilyAddressViewModels.map((familyAddress) => (
                                    <TableRow key={familyAddress.model.id}>
                                        <TableCell>{familyAddress.model.addressLine1}</TableCell>
                                        <TableCell align="center">{familyAddress.model.addressLine2}</TableCell>
                                        <TableCell align="center">{familyAddress.model.addressLine3}</TableCell>
                                        <TableCell align="center">{familyAddress.model.city}</TableCell>
                                        <TableCell align="center">{familyAddress.model.county}</TableCell>
                                        <TableCell align="center">{familyAddress.model.postcode}</TableCell>
                                        <TableCell align="center">
                                            {(upsertViewModel.IsLoading || props.applicationFormViewModel.model.isSubmitted || storesContext.Domain.SaveStore.isSaving) ==
                                                false && (
                                                <Button
                                                    onClick={() => {
                                                        familyAddress.delete(props.personalDetailsViewModel);
                                                    }}
                                                >
                                                    <BinSVG />
                                                </Button>
                                            )}
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                )}
            </Box>
        </>
    ));
};
